import { getImage } from "api";
import { useEffect, useState } from "react";
import { getCachedImage, setCachedImage } from "utils";
import styled from "styled-components";
import useAdBlockStore from "store/AdBlockStore";
import { Skeleton } from "antd";

export const ImagePreview = ({
    filename = '',
    style = {},
}) => {
    const isLoading = useAdBlockStore(state => state.isLoading);
    const setIsLoading = useAdBlockStore(state => state.setIsLoading);
    const blockImg = useAdBlockStore(state => state.blockImg);
    const setBlockImg = useAdBlockStore(state => state.setBlockImg);

    const [error, setError] = useState(null);

    const fetchImage = async () => {
        try {
            // Check if the image is cached
            const cachedImage = await getCachedImage(filename);
            if (cachedImage) {
                // Convert base64 to data URI for display
                setBlockImg(`data:image/jpeg;base64,${cachedImage}`);
                setIsLoading(false);
                return;
            }
            // Fetch the image from the API
            const img = await getImage(filename);

            console.log('IMG', img)
            if (img.success) {
                // Cache the fetched image
                await setCachedImage(filename, img.payload);
                // Convert base64 to data URI for display
                setBlockImg(`data:image/jpeg;base64,${img.payload}`);
                setIsLoading(false);
            }
        } catch (error) {
            setError(error);
        }
    };

    useEffect(() => {
        if (filename) {
            // Clear the previous image immediately to prevent flash of old content
            setBlockImg(null);
            setIsLoading(true);
            fetchImage();
        } else {
            setBlockImg(null);
            setIsLoading(false);
        }
    }, [filename]);


    const imageStyle = {
        ...style,
    };

    return (
        <Container>
            {error && <div className="error-message">Error loading image: {error.message}</div>}
            {isLoading ? (
                <div style={{
                    width: '100%',
                    // height: '100%',
                    height: 'calc(100vh - 216px)', // Adjust based on your layout
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Skeleton.Image active style={{
                        width: '100vw',
                        height: 'calc(100vh - 216px)', // Adjust based on your layout
                        // objectFit: 'contain',
                    }} />
                </div>
            ) : blockImg ? (
                <>
                    <img
                        src={blockImg}
                        alt="Ad Block"
                        style={imageStyle}
                    />
                </>
            ) : (
                <div style={{ textAlign: 'center', color: '#888' }}>
                    No Image Available Yet.
                </div>
            )}
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 216px); 
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: opacity 300ms ease;
    &:hover {
        opacity: ${(props) => props.showOverlay ? 0.8 : 1};
    }
`;
